import { useCallback, useMemo } from 'react';
import { useFetchUser } from '@/auth/hooks';
import { useExplorer } from '@/hooks/useExplorer';
import type { AiRoutingContext } from '@/services/aero/cbAiApi';
import {
  postApiExplorerKvl,
  awaitIdentityReady,
} from '@/services/aero/cbAiApi';

export function useKvlLogger() {
  const { user, isLoggedIn } = useFetchUser();
  const { siteName } = useExplorer();
  const tenantName = siteName || user?.active_site?.site_name;

  const routingContext = useMemo<AiRoutingContext>(
    () => ({
      isAuthenticated: Boolean(isLoggedIn),
      tenantName,
    }),
    [isLoggedIn, tenantName]
  );

  const logKvl = useCallback(
    (kvl: Record<string, string>) => {
      void awaitIdentityReady()
        .then(() => postApiExplorerKvl(kvl, routingContext))
        .catch(() => {}); // ignore telemetry failures
    },
    [routingContext]
  );

  return { logKvl };
}
